<template>
  <div>
    <!-- Step 1: Platform Selection -->
    <div v-if="step === 1" class="platform-selection py-3">
      <p class="text-muted mb-2">Choose the platform for this order:</p>
      <div class="alert alert-info py-2 px-3 mb-4 small">
        <i class="bi bi-info-circle me-2"></i>
        <strong>Note:</strong> eBay orders are synced automatically and can't be added manually.
      </div>
      <div class="row g-3" :class="{'default-all': allPlatforms}">
        <div v-for="platform in platforms" :key="platform.key" class="col-6 col-md-4 platform-container" :class="{default: platform.active}">
          <button
            type="button"
            class="platform-card btn w-100 h-100 p-4 text-center"
            @click="selectPlatform(platform.key)"
          >
            <img :src="platform.favicon" class="platform-icon mb-2" :alt="`favicon for ${platform.key}`" />
            <div class="platform-name">{{ platform.label }}</div>
          </button>
        </div>
        <div class="col-6 col-md-4" v-if="!allPlatforms">
          <button type="button"
                  class="platform-card btn w-100 h-100 p-4 text-center"
                  @click="allPlatforms=true">
              <i class="bi bi-plus platform-icon mb-2"></i>
              <div class="platform-name">More</div>
          </button>
        </div>
      </div>
    </div>

    <!-- Step 2: Order Form -->
    <order-form
      v-else-if="step === 2"
      ref="orderFormRef"
      :platform="selectedPlatform"
      :edit-order="editOrder"
      :prefill-items="prefillItems"
      @saved="onSaved"
    />
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, defineExpose, computed } from 'vue'
import OrderForm from '@/app/components/orders/OrderForm.vue'
import { useStore } from 'vuex'
const store = useStore()

const props = defineProps({
  editOrder: { type: Object, default: null },
  prefillItems: { type: Array, default: null },
})

const emit = defineEmits(['saved'])
const allPlatforms = ref(false)

const platforms = computed(() => store.state.supportedStores.filter(p => p.manual))

const step = ref(props.editOrder ? 2 : 1)
const selectedPlatform = ref(props.editOrder?.remote_store ?? null)
const orderFormRef = ref(null)

function selectPlatform(platform) {
  selectedPlatform.value = platform
  step.value = 2
}

function onSaved(result) {
  step.value = 3
  emit('saved', result)
}

defineExpose({ step })
</script>

<style lang="scss" scoped>
@import '@/assets/sass/_variables-esc.scss';

.platform-card {
  border: 2px solid $gray-300;
  background: $white;
  transition: all 0.2s ease;
  border-radius: 0.5rem;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &:hover {
    border-color: $info;
    background: $gray-100;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  &:active { transform: translateY(0); }
}
.platform-icon {
  font-size: 2.5rem;
  color: $gray-600;
  display: block;
}
.platform-name {
  font-weight: 600;
  color: $gray-900;
  font-size: 1rem;
}
.platform-card:hover .platform-icon { color: $info; }

.platform-container {display:none;}
.platform-container.default {display:block;}
.default-all .platform-container {display:block;}

</style>
